import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=2bd8cba2&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.css?vue&type=style&index=0&id=2bd8cba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8cba2",
  null
  
)

export default component.exports